/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bots: NonNullable<unknown> }} Products_Leveling_Faq_Bots_AInputs */



/**
* | output |
* | --- |
* | "{bots} hand over exact levels from their leaderboards. Official JSON exports from Lurkr and Kiai work too. You can also import from perk roles members hold, ..." |
*
* @param {Products_Leveling_Faq_Bots_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_bots_a = /** @type {((inputs: Products_Leveling_Faq_Bots_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Bots_AInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.bots} передают точные уровни из своих таблиц лидеров. Подходят и официальные JSON-файлы экспорта из Lurkr и Kiai. Также можно перенести уровни по ролям-привилегиям участников, а участники могут запросить свой прежний уровень через /claim.`)
	return /** @type {LocalizedString} */ (`${i?.bots} hand over exact levels from their leaderboards. Official JSON exports from Lurkr and Kiai work too. You can also import from perk roles members hold, and members can ask for the level they had with /claim.`)
});